var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "page-title-header"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('BreadCrumb', {
    attrs: {
      "parentRouteName": "BookingPresetList",
      "extra-items": _vm.isEditing ? [{
        text: _vm.bookingPreset.name,
        to: 'BookingCenterBookingList',
        params: _vm.$route.params.id
      }, '編輯預約設定檔'] : ['新增預約設定檔']
    }
  })], 1)]), _c('div', {
    staticClass: "email-wrapper wrapper"
  }, [_c('div', {
    staticClass: "row bg-white"
  }, [_c('div', {
    staticClass: "col-md-2 mail-sidebar pt-3"
  }, [_c('StepNavigation', {
    ref: "stepNavigation",
    attrs: {
      "steps": _vm.navigationSteps
    },
    on: {
      "changed": function changed(newStep) {
        return _vm.step = newStep.hash;
      }
    }
  })], 1), _c('div', {
    staticClass: "col-md-10 main-view"
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading
    }
  }, [_c('b-card', [_vm.step == '' ? _c('section', [_c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2"
  }, [_c('h4', {
    staticClass: "col-12 col-xl-6 mb-3 font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.isEditing ? "編輯預約設定檔" : "新增預約設定檔") + " ")]), _c('div', {
    staticClass: "col-12 col-xl-8"
  }, [_vm.validationErrors ? _c('validation-error-alert', {
    attrs: {
      "errors": _vm.validationErrors
    }
  }) : _vm._e(), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "*預約設定檔名稱"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "state": _vm.v$.bookingPreset.name.$error ? false : null
    },
    model: {
      value: _vm.bookingPreset.name,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset, "name", $$v);
      },
      expression: "bookingPreset.name"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.bookingPreset.name.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "*預約類型"
    }
  }, [_vm.hasBookingPresetTypePermission ? _c('b-form-radio-group', {
    attrs: {
      "options": _vm.bookingPresetTypes
    },
    model: {
      value: _vm.bookingPreset.type,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset, "type", $$v);
      },
      expression: "bookingPreset.type"
    }
  }) : _c('p', {
    staticClass: "mt-1"
  }, [_vm._v(" 無權限 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "填寫權限"
    }
  }, [_c('b-form-checkbox-group', {
    attrs: {
      "options": _vm.permissionOptions
    },
    model: {
      value: _vm.bookingPreset.config.permissions,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config, "permissions", $$v);
      },
      expression: "bookingPreset.config.permissions"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "預約設定檔說明"
    }
  }, [_c('b-form-textarea', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    model: {
      value: _vm.bookingPreset.config.description,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config, "description", $$v);
      },
      expression: "bookingPreset.config.description"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "是否開放預約",
      "description": "是否允許使用者新增預約"
    }
  }, [_c('b-form-select', {
    model: {
      value: _vm.bookingPreset.status,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset, "status", $$v);
      },
      expression: "bookingPreset.status"
    }
  }, [_c('b-form-select-option', {
    attrs: {
      "value": "published"
    }
  }, [_vm._v("發布")]), _c('b-form-select-option', {
    attrs: {
      "value": "draft"
    }
  }, [_vm._v("草稿")]), _c('b-form-select-option', {
    attrs: {
      "value": "closed"
    }
  }, [_vm._v("關閉")])], 1)], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "* 開始時間"
    }
  }, [_c('AppDateTimePicker', {
    attrs: {
      "placeholderForDate": "選擇日期",
      "placeholderForTime": "選擇時間",
      "has-error": _vm.v$.bookingPreset.start_at.$error
    },
    model: {
      value: _vm.bookingPreset.start_at,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset, "start_at", $$v);
      },
      expression: "bookingPreset.start_at"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.bookingPreset.start_at.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "* 結束時間"
    }
  }, [_c('AppDateTimePicker', {
    attrs: {
      "placeholderForDate": "選擇日期",
      "placeholderForTime": "選擇時間",
      "has-error": _vm.v$.bookingPreset.end_at.$error || _vm.v$.bookingPreset.start_at.beforeEndAt.$invalid
    },
    model: {
      value: _vm.bookingPreset.end_at,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset, "end_at", $$v);
      },
      expression: "bookingPreset.end_at"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.bookingPreset.end_at.$error
    }
  }, [_vm._v(" 此欄位為必填 ")]), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.bookingPreset.start_at.beforeEndAt.$invalid
    }
  }, [_vm._v(" 結束時間必須大於起始時間 ")])], 1)], 1)]), _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(" 返回 ")]), _c('b-button', {
    attrs: {
      "disabled": !_vm.hasBookingPresetTypePermission,
      "variant": "success"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(" 儲存 ")])], 1)]) : _vm._e(), _vm.step == '#welcome' && _vm.bookingPreset.config.welcome_page ? _c('section', [_c('h4', {
    staticClass: "mb-3 font-weight-bold"
  }, [_vm._v("歡迎頁")]), _vm.validationErrors ? _c('validation-error-alert', {
    attrs: {
      "errors": _vm.validationErrors
    }
  }) : _vm._e(), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "啟用"
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: _vm.bookingPreset.config.welcome_page.enable,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.welcome_page, "enable", $$v);
      },
      expression: "bookingPreset.config.welcome_page.enable"
    }
  }, [_vm._v("啟用")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_vm._v(" 主圖 "), _c('p', {
          staticClass: "text-black-50 mt-2",
          staticStyle: {
            "font-size": ".75rem"
          }
        }, [_vm._v("寬 x 高：1400px x 不限")])];
      },
      proxy: true
    }, {
      key: "default",
      fn: function fn() {
        return [_c('AppFileUploader', {
          attrs: {
            "placeholder-when-uploaded": "（查看檔案）",
            "placeholder-when-empty": ""
          },
          model: {
            value: _vm.bookingPreset.config.welcome_page.banner_image,
            callback: function callback($$v) {
              _vm.$set(_vm.bookingPreset.config.welcome_page, "banner_image", $$v);
            },
            expression: "bookingPreset.config.welcome_page.banner_image"
          }
        })];
      },
      proxy: true
    }], null, false, 3103129713)
  }), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "標題"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "disabled": !_vm.bookingPreset.config.welcome_page.enable
    },
    model: {
      value: _vm.bookingPreset.config.welcome_page.form_title,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.welcome_page, "form_title", $$v);
      },
      expression: "bookingPreset.config.welcome_page.form_title"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "副標題"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "disabled": !_vm.bookingPreset.config.welcome_page.enable
    },
    model: {
      value: _vm.bookingPreset.config.welcome_page.form_desc,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.welcome_page, "form_desc", $$v);
      },
      expression: "bookingPreset.config.welcome_page.form_desc"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "內容說明"
    }
  }, [_c('TrixEditor', {
    attrs: {
      "readonly": !_vm.bookingPreset.config.welcome_page.enable
    },
    model: {
      value: _vm.bookingPreset.config.welcome_page.content,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.welcome_page, "content", $$v);
      },
      expression: "bookingPreset.config.welcome_page.content"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "按鈕文字"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "disabled": !_vm.bookingPreset.config.welcome_page.enable
    },
    model: {
      value: _vm.bookingPreset.config.welcome_page.button_text,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.welcome_page, "button_text", $$v);
      },
      expression: "bookingPreset.config.welcome_page.button_text"
    }
  })], 1), _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(" 返回 ")]), _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(" 儲存 ")])], 1)], 1) : _vm._e(), _vm.step == '#content' && _vm.bookingPreset.config.content_page ? _c('section', [_c('h4', {
    staticClass: "mb-3 font-weight-bold"
  }, [_vm._v("內容頁")]), _vm.validationErrors ? _c('validation-error-alert', {
    attrs: {
      "errors": _vm.validationErrors
    }
  }) : _vm._e(), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "每頁都顯示"
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: _vm.bookingPreset.config.content_page.displayed_in_every_page,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.content_page, "displayed_in_every_page", $$v);
      },
      expression: "bookingPreset.config.content_page.displayed_in_every_page"
    }
  }, [_vm._v("每頁都顯示")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_vm._v(" 主圖 "), _c('p', {
          staticClass: "text-black-50 mt-2",
          staticStyle: {
            "font-size": ".75rem"
          }
        }, [_vm._v("寬 x 高：1400px x 不限")])];
      },
      proxy: true
    }, {
      key: "default",
      fn: function fn() {
        return [_c('AppFileUploader', {
          attrs: {
            "placeholder-when-uploaded": "（查看檔案）",
            "placeholder-when-empty": ""
          },
          model: {
            value: _vm.bookingPreset.config.content_page.banner_image,
            callback: function callback($$v) {
              _vm.$set(_vm.bookingPreset.config.content_page, "banner_image", $$v);
            },
            expression: "bookingPreset.config.content_page.banner_image"
          }
        })];
      },
      proxy: true
    }], null, false, 329526434)
  }), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_vm._v(" 背景底圖 "), _c('p', {
          staticClass: "text-black-50 mt-2",
          staticStyle: {
            "font-size": ".75rem"
          }
        }, [_vm._v("寬 x 高：1400px x 不限")])];
      },
      proxy: true
    }, {
      key: "default",
      fn: function fn() {
        return [_c('AppFileUploader', {
          attrs: {
            "placeholder-when-uploaded": "（查看檔案）",
            "placeholder-when-empty": ""
          },
          model: {
            value: _vm.bookingPreset.config.content_page.background_image,
            callback: function callback($$v) {
              _vm.$set(_vm.bookingPreset.config.content_page, "background_image", $$v);
            },
            expression: "bookingPreset.config.content_page.background_image"
          }
        })];
      },
      proxy: true
    }], null, false, 3400810069)
  }), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "標題"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text"
    },
    model: {
      value: _vm.bookingPreset.config.content_page.form_title,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.content_page, "form_title", $$v);
      },
      expression: "bookingPreset.config.content_page.form_title"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "副標題"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text"
    },
    model: {
      value: _vm.bookingPreset.config.content_page.form_desc,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.content_page, "form_desc", $$v);
      },
      expression: "bookingPreset.config.content_page.form_desc"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "內容說明"
    }
  }, [_c('TrixEditor', {
    model: {
      value: _vm.bookingPreset.config.content_page.content,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.content_page, "content", $$v);
      },
      expression: "bookingPreset.config.content_page.content"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "送出按鈕文字"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text"
    },
    model: {
      value: _vm.bookingPreset.config.content_page.submit_button_text,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.content_page, "submit_button_text", $$v);
      },
      expression: "bookingPreset.config.content_page.submit_button_text"
    }
  })], 1), _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(" 返回 ")]), _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(" 儲存 ")])], 1)], 1) : _vm._e(), _vm.step == '#finished' && _vm.bookingPreset.config.finished_page ? _c('section', [_c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2"
  }, [_c('h4', {
    staticClass: "col-12 col-xl-12 mb-3 font-weight-bold"
  }, [_vm._v("完成頁")]), _c('h5', {
    staticClass: "col-12 col-xl-12 mb-3 font-weight-bold"
  }, [_vm._v("一般設定")]), _c('div', {
    staticClass: "col-12 col-xl-12"
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "標題"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "請輸入標題"
    },
    model: {
      value: _vm.bookingPreset.config.finished_page.title,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.finished_page, "title", $$v);
      },
      expression: "bookingPreset.config.finished_page.title"
    }
  })], 1), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-12 col-lg-2 col-form-label col-form-label-sm"
  }, [_vm._v("內容說明")]), _c('div', {
    staticClass: "col-12 col-lg-10"
  }, [_c('TrixEditor', {
    model: {
      value: _vm.bookingPreset.config.finished_page.content,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.finished_page, "content", $$v);
      },
      expression: "bookingPreset.config.finished_page.content"
    }
  })], 1)]), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_vm._v(" 主圖 "), _c('p', {
          staticClass: "text-black-50 mt-2",
          staticStyle: {
            "font-size": ".75rem"
          }
        }, [_vm._v("寬 x 高：1400px x 不限")])];
      },
      proxy: true
    }, {
      key: "default",
      fn: function fn() {
        return [_c('AppFileUploader', {
          attrs: {
            "placeholder-when-uploaded": "（查看檔案）",
            "placeholder-when-empty": ""
          },
          model: {
            value: _vm.bookingPreset.config.finished_page.banner_image,
            callback: function callback($$v) {
              _vm.$set(_vm.bookingPreset.config.finished_page, "banner_image", $$v);
            },
            expression: "bookingPreset.config.finished_page.banner_image"
          }
        })];
      },
      proxy: true
    }], null, false, 2774217945)
  })], 1), _c('h5', {
    staticClass: "col-12 col-xl-12 mb-3 font-weight-bold"
  }, [_vm._v("按鈕設定")]), _c('div', {
    staticClass: "col-12 col-xl-8"
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "顯示繼續預約按鈕"
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: _vm.bookingPreset.config.finished_page.enabled_next_booking_button,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.finished_page, "enabled_next_booking_button", $$v);
      },
      expression: "bookingPreset.config.finished_page.enabled_next_booking_button"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "顯示預約紀錄按鈕"
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: _vm.bookingPreset.config.finished_page.enabled_go_booking_list_button,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.finished_page, "enabled_go_booking_list_button", $$v);
      },
      expression: "bookingPreset.config.finished_page.enabled_go_booking_list_button"
    }
  })], 1)], 1), _c('h5', {
    staticClass: "col-12 col-xl-12 mb-3 font-weight-bold"
  }, [_vm._v("訊息發送")]), _c('div', {
    staticClass: "col-12 col-xl-8"
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "啟用預約後訊息"
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: _vm.bookingPreset.config.finished_page.send_messages.enabled,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.finished_page.send_messages, "enabled", $$v);
      },
      expression: "bookingPreset.config.finished_page.send_messages.enabled"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "訊息內容"
    }
  }, [_c('b-form-textarea', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "rows": "4"
    },
    model: {
      value: _vm.bookingPreset.config.finished_page.send_messages.text,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.finished_page.send_messages, "text", $$v);
      },
      expression: "bookingPreset.config.finished_page.send_messages.text"
    }
  })], 1)], 1), _c('hr', {
    staticClass: "col-12"
  }), _c('div', {
    staticClass: "col-12 col-xl-8 mb-4"
  }, [_c('h5', {
    staticClass: "mb-2 font-weight-bold"
  }, [_vm._v("預約人")]), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "標題"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "請輸入預約人標題"
    },
    model: {
      value: _vm.bookingPreset.config.finished_page.booking_person_title,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.finished_page, "booking_person_title", $$v);
      },
      expression: "bookingPreset.config.finished_page.booking_person_title"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "啟用顯示客製欄位"
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: _vm.bookingPreset.config.finished_page.enabled_booking_person_custom_fields,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.finished_page, "enabled_booking_person_custom_fields", $$v);
      },
      expression: "bookingPreset.config.finished_page.enabled_booking_person_custom_fields"
    }
  })], 1), _c('JsonEditor', {
    attrs: {
      "lines": 4
    },
    model: {
      value: _vm.bookingPreset.config.finished_page.booking_person,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.finished_page, "booking_person", $$v);
      },
      expression: "bookingPreset.config.finished_page.booking_person"
    }
  })], 1), _c('div', {
    staticClass: "col-12 col-xl-8 mb-4"
  }, [_c('h5', {
    staticClass: "mb-2 font-weight-bold"
  }, [_vm._v("預約資訊")]), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "標題"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "請輸入預約資訊標題"
    },
    model: {
      value: _vm.bookingPreset.config.finished_page.booking_info_title,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.finished_page, "booking_info_title", $$v);
      },
      expression: "bookingPreset.config.finished_page.booking_info_title"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "啟用顯示客製欄位"
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: _vm.bookingPreset.config.finished_page.enabled_booking_info_custom_fields,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.finished_page, "enabled_booking_info_custom_fields", $$v);
      },
      expression: "bookingPreset.config.finished_page.enabled_booking_info_custom_fields"
    }
  })], 1), _c('JsonEditor', {
    attrs: {
      "lines": 4
    },
    model: {
      value: _vm.bookingPreset.config.finished_page.booking_info,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.finished_page, "booking_info", $$v);
      },
      expression: "bookingPreset.config.finished_page.booking_info"
    }
  })], 1), _c('div', {
    staticClass: "col-12 col-xl-8"
  }, [_c('h5', {
    staticClass: "mb-2 font-weight-bold"
  }, [_vm._v("表單內容")]), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "標題"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "請輸入表單內容標題"
    },
    model: {
      value: _vm.bookingPreset.config.finished_page.form_content_title,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.finished_page, "form_content_title", $$v);
      },
      expression: "bookingPreset.config.finished_page.form_content_title"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "啟用顯示客製欄位"
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: _vm.bookingPreset.config.finished_page.enabled_form_content_custom_fields,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.finished_page, "enabled_form_content_custom_fields", $$v);
      },
      expression: "bookingPreset.config.finished_page.enabled_form_content_custom_fields"
    }
  })], 1), _c('JsonEditor', {
    attrs: {
      "lines": 4
    },
    model: {
      value: _vm.bookingPreset.config.finished_page.form_content,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.finished_page, "form_content", $$v);
      },
      expression: "bookingPreset.config.finished_page.form_content"
    }
  })], 1)]), _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(" 返回 ")]), _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(" 儲存 ")])], 1)]) : _vm._e(), _vm.step == '#fields' ? _c('section', [_c('NameBlock', {
    attrs: {
      "label": '預約名稱',
      "name": _vm.bookingPreset.name
    }
  }), _c('div', [_vm.bookingPreset.id ? _c('DynamicFormEditor', {
    attrs: {
      "editor-title": "欄位設定",
      "form-type": 'booking',
      "input-subjects": _vm.bookingPreset.config.fields,
      "pages": _vm.bookingPreset.config.pages,
      "sections": _vm.bookingPreset.config.sections,
      "validate-subject": _vm.validSubject,
      "booking-preset-type": _vm.bookingPreset.type,
      "start-at-field-id": _vm.dataModel.startAtFieldId,
      "validation-message": "標題不得為空",
      "enable-visible-condition": ""
    },
    on: {
      "output": _vm.saveFields,
      "cancel": function cancel($event) {
        return _vm.$router.push({
          name: 'BookingPresetList'
        });
      },
      "change": _vm.handleFieldChange
    }
  }) : _vm._e()], 1)], 1) : _vm._e(), _vm.step == '#mapping' ? _c('section', [_c('NameBlock', {
    attrs: {
      "label": '預約設定檔名稱',
      "name": _vm.bookingPreset.name
    }
  }), _c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2"
  }, [_c('h4', {
    staticClass: "col-12 col-xl-12 mb-3 font-weight-bold"
  }, [_vm._v(" 預約資料設定 ")]), _c('h5', {
    staticClass: "col-12 col-xl-12 mb-3 font-weight-bold"
  }, [_vm._v(" 欄位對應 ")]), _c('div', {
    staticClass: "col-12 col-xl-9"
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "標題顯示欄位"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.titleOptions
    },
    model: {
      value: _vm.bookingPreset.config.booking_mapping.bookings.title,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.booking_mapping.bookings, "title", $$v);
      },
      expression: "\n                        bookingPreset.config.booking_mapping.bookings.title\n                      "
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "預約開始欄位"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.dateFieldCandidates
    },
    model: {
      value: _vm.bookingPreset.config.booking_mapping.bookings.start_at,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.booking_mapping.bookings, "start_at", $$v);
      },
      expression: "\n                        bookingPreset.config.booking_mapping.bookings.start_at\n                      "
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "預約結束欄位"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.dateFieldCandidates,
      "disabled": _vm.bookingPreset.type == 'wizard'
    },
    model: {
      value: _vm.bookingPreset.config.booking_mapping.bookings.end_at,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.booking_mapping.bookings, "end_at", $$v);
      },
      expression: "\n                        bookingPreset.config.booking_mapping.bookings.end_at\n                      "
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('b-tooltip', {
          attrs: {
            "target": "end-slot-minutes",
            "placement": "top"
          }
        }, [_vm._v(" 在結束時間之後加上一個固定時間 ")]), _c('span', {
          attrs: {
            "id": "end-slot-minutes"
          }
        }, [_vm._v("預留時間區段(分鐘)"), _c('span', {
          staticClass: "mdi mdi-help-circle-outline"
        })])];
      },
      proxy: true
    }], null, false, 3401425447)
  }, [_c('b-form-input', {
    ref: "endSlotMinutes",
    attrs: {
      "placeholder": "請填入分鐘",
      "type": "number",
      "min": "0"
    },
    on: {
      "blur": _vm.sanitizeEndSlotMinutes
    },
    model: {
      value: _vm.bookingPreset.config.booking_mapping.bookings.end_slot_minutes,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.booking_mapping.bookings, "end_slot_minutes", $$v);
      },
      expression: "bookingPreset.config.booking_mapping.bookings.end_slot_minutes"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.bookingPreset.config.booking_mapping.bookings.end_slot_minutes.$error
    }
  }, [_vm._v(" " + _vm._s(_vm.presentValidationErrors("bookingPreset.config.booking_mapping.bookings.end_slot_minutes")) + " ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "前台不顯示結束時間"
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: _vm.bookingPreset.config.display.should_hide_end_time,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.display, "should_hide_end_time", $$v);
      },
      expression: "bookingPreset.config.display.should_hide_end_time"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "預約開始條件(分店)"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.branchFieldCandidates,
      "disabled": !_vm.bookingPreset.config.booking_mapping.bookings.start_at
    },
    model: {
      value: _vm.bookingPreset.config.booking_mapping.bookings.start_at_by_branch,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.booking_mapping.bookings, "start_at_by_branch", $$v);
      },
      expression: "\n                        bookingPreset.config.booking_mapping.bookings.start_at_by_branch\n                      "
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('b-tooltip', {
          attrs: {
            "target": "closing-time",
            "placement": "top"
          }
        }, [_vm._v(" 店家當日休店時段，被預約的服務不會晚於此時段 ")]), _c('span', {
          attrs: {
            "id": "closing-time"
          }
        }, [_vm._v("*當日休店時間"), _c('span', {
          staticClass: "mdi mdi-help-circle-outline"
        })])];
      },
      proxy: true
    }], null, false, 53660641)
  }, [_c('AppTimePicker', {
    ref: "closingTime",
    attrs: {
      "styleType": "unlimited"
    },
    model: {
      value: _vm.bookingPreset.config.booking_mapping.bookings.closing_time,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.booking_mapping.bookings, "closing_time", $$v);
      },
      expression: "bookingPreset.config.booking_mapping.bookings.closing_time"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.bookingPreset.config.booking_mapping.bookings.closing_time.$error
    }
  }, [_vm._v(" " + _vm._s(_vm.presentValidationErrors("bookingPreset.config.booking_mapping.bookings.closing_time")) + " ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "提前預約設定"
    }
  }, [_c('label', {
    staticClass: "py-2 d-inline-flex align-items-center"
  }, [_c('b-form-radio', {
    attrs: {
      "name": "lead-time-options",
      "value": "none"
    },
    model: {
      value: _vm.bookingPreset.config.basic.lead_time.type,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.basic.lead_time, "type", $$v);
      },
      expression: "bookingPreset.config.basic.lead_time.type"
    }
  }), _vm._v(" 無需提前預約 ")], 1), _c('br'), _c('label', {
    staticClass: "py-2 d-inline-flex align-items-center"
  }, [_c('b-form-radio', {
    attrs: {
      "name": "lead-time-options",
      "value": "day"
    },
    model: {
      value: _vm.bookingPreset.config.basic.lead_time.type,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.basic.lead_time, "type", $$v);
      },
      expression: "bookingPreset.config.basic.lead_time.type"
    }
  }), _vm._v(" 需提前 "), _c('b-form-input', {
    staticClass: "d-inline-block mx-1",
    staticStyle: {
      "width": "70px"
    },
    attrs: {
      "disabled": _vm.bookingPreset.config.basic.lead_time.type !== 'day',
      "type": "number",
      "min": "0",
      "size": "sm"
    },
    model: {
      value: _vm.bookingPreset.config.basic.lead_time.amount_day,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.basic.lead_time, "amount_day", $$v);
      },
      expression: "bookingPreset.config.basic.lead_time.amount_day"
    }
  }), _vm._v(" 天預約 ")], 1), _c('br'), _c('label', {
    staticClass: "py-2 d-inline-flex align-items-center"
  }, [_c('b-form-radio', {
    attrs: {
      "name": "lead-time-options",
      "value": "minute"
    },
    model: {
      value: _vm.bookingPreset.config.basic.lead_time.type,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.basic.lead_time, "type", $$v);
      },
      expression: "bookingPreset.config.basic.lead_time.type"
    }
  }), _vm._v(" 需提前 "), _c('b-form-input', {
    staticClass: "d-inline-block mx-1",
    staticStyle: {
      "width": "70px"
    },
    attrs: {
      "disabled": _vm.bookingPreset.config.basic.lead_time.type !== 'minute',
      "type": "number",
      "min": "0",
      "size": "sm"
    },
    model: {
      value: _vm.bookingPreset.config.basic.lead_time.amount_minute,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.basic.lead_time, "amount_minute", $$v);
      },
      expression: "bookingPreset.config.basic.lead_time.amount_minute"
    }
  }), _vm._v(" 分鐘預約 ")], 1)]), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "*預約時間限制"
    }
  }, [_c('label', {
    staticClass: "py-2 d-inline-flex align-items-center"
  }, [_c('b-form-radio', {
    attrs: {
      "name": "booking-window-options",
      "value": "none"
    },
    model: {
      value: _vm.bookingPreset.config.basic.booking_window.type,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.basic.booking_window, "type", $$v);
      },
      expression: "bookingPreset.config.basic.booking_window.type"
    }
  }), _vm._v(" 不限制 ")], 1), _c('br'), _c('label', {
    staticClass: "py-2 d-inline-flex align-items-center"
  }, [_c('b-form-radio', {
    attrs: {
      "name": "booking-window-options",
      "value": "day"
    },
    model: {
      value: _vm.bookingPreset.config.basic.booking_window.type,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.basic.booking_window, "type", $$v);
      },
      expression: "bookingPreset.config.basic.booking_window.type"
    }
  }), _vm._v(" 只能預約 "), _c('b-form-input', {
    staticClass: "d-inline-block mx-1",
    staticStyle: {
      "width": "70px"
    },
    attrs: {
      "disabled": _vm.bookingPreset.config.basic.booking_window.type !== 'day',
      "type": "number",
      "min": "0",
      "size": "sm"
    },
    model: {
      value: _vm.bookingPreset.config.basic.booking_window.amount_day,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.basic.booking_window, "amount_day", $$v);
      },
      expression: "bookingPreset.config.basic.booking_window.amount_day"
    }
  }), _vm._v(" 天內的預約 "), _c('span', {
    staticClass: "ml-2",
    attrs: {
      "id": "booking-window-tooltip-trigger"
    }
  }, [_c('span', {
    staticClass: "mdi mdi-help-circle-outline"
  })]), _c('b-tooltip', {
    attrs: {
      "target": "booking-window-tooltip-trigger",
      "placement": "top"
    }
  }, [_vm._v(" 1 天代表當日；2 代表當日與隔日 ")])], 1), _c('br'), _c('label', {
    staticClass: "py-2 d-inline-flex align-items-center"
  }, [_c('b-form-radio', {
    attrs: {
      "name": "booking-window-options",
      "value": "minute"
    },
    model: {
      value: _vm.bookingPreset.config.basic.booking_window.type,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.basic.booking_window, "type", $$v);
      },
      expression: "bookingPreset.config.basic.booking_window.type"
    }
  }), _vm._v(" 只能預約未來 "), _c('b-form-input', {
    staticClass: "d-inline-block mx-1",
    staticStyle: {
      "width": "70px"
    },
    attrs: {
      "disabled": _vm.bookingPreset.config.basic.booking_window.type !== 'minute',
      "type": "number",
      "min": "0",
      "size": "sm"
    },
    model: {
      value: _vm.bookingPreset.config.basic.booking_window.amount_minute,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.basic.booking_window, "amount_minute", $$v);
      },
      expression: "bookingPreset.config.basic.booking_window.amount_minute"
    }
  }), _vm._v(" 分鐘內的預約 ")], 1)]), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "預約提示"
    }
  }, [_c('TrixEditor', {
    model: {
      value: _vm.bookingPreset.config.basic.tips,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.basic, "tips", $$v);
      },
      expression: "bookingPreset.config.basic.tips"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "分店欄位"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.branchFieldCandidates
    },
    model: {
      value: _vm.bookingPreset.config.branch.field_id,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.branch, "field_id", $$v);
      },
      expression: "\n                        bookingPreset.config.branch.field_id\n                      "
    }
  })], 1)], 1), _c('h5', {
    staticClass: "col-12 col-xl-12 mt-5 mb-3 font-weight-bold"
  }, [_vm._v(" 手機驗證 ")]), _c('div', {
    staticClass: "col-12 col-xl-8"
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "驗證時機"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": [{
        text: '無須驗證',
        value: null
      }, {
        text: '填寫表單時驗證',
        value: 'current_page'
      }, {
        text: '填寫後下頁驗證(尚未開放此功能)',
        value: 'next_page'
      }]
    },
    model: {
      value: _vm.bookingPreset.config.phone_verification.timing,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.phone_verification, "timing", $$v);
      },
      expression: "bookingPreset.config.phone_verification.timing"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "手機驗證欄位"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.textFieldCandidates,
      "disabled": !_vm.bookingPreset.config.phone_verification.timing
    },
    model: {
      value: _vm.bookingPreset.config.phone_verification.field_id,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.phone_verification, "field_id", $$v);
      },
      expression: "bookingPreset.config.phone_verification.field_id"
    }
  }), _vm.bookingPreset.config.phone_verification.timing ? _c('b-form-invalid-feedback', {
    attrs: {
      "state": !(_vm.bookingPreset.config.phone_verification.timing && !_vm.bookingPreset.config.phone_verification.field_id)
    }
  }, [_vm._v(" 請選擇需要驗證的欄位 ")]) : _vm._e()], 1)], 1), _c('h5', {
    staticClass: "col-12 col-xl-12 mt-5 mb-3 font-weight-bold"
  }, [_vm._v(" 預約狀態 ")]), _c('div', {
    staticClass: "col-12 col-xl-8"
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "狀態欄位"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.collectionFieldCandidates
    },
    model: {
      value: _vm.bookingPreset.config.booking_mapping.bookings.status,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.booking_mapping.bookings, "status", $$v);
      },
      expression: "\n                        bookingPreset.config.booking_mapping.bookings.status\n                      "
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "狀態預設值"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text"
    },
    model: {
      value: _vm.bookingPreset.config.booking_mapping.default_status_value,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.booking_mapping, "default_status_value", $$v);
      },
      expression: "\n                        bookingPreset.config.booking_mapping\n                          .default_status_value\n                      "
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "狀態文字對應"
    }
  }, [_c('JsonEditor', {
    ref: "statusFilterMapping",
    attrs: {
      "height": "128px"
    },
    model: {
      value: _vm.bookingPreset.config.provider_config.status_filter_mapping,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.provider_config, "status_filter_mapping", $$v);
      },
      expression: "\n                        bookingPreset.config.provider_config.status_filter_mapping\n                      "
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.bookingPreset.config.provider_config.status_filter_mapping.$error
    }
  }, [_vm._v(" " + _vm._s(_vm.presentValidationErrors("bookingPreset.config.provider_config.status_filter_mapping")) + " ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "狀態顯示編輯按鈕"
    }
  }, [_c('JsonEditor', {
    ref: "editLiffMapping",
    attrs: {
      "height": "64px"
    },
    model: {
      value: _vm.bookingPreset.config.can_edit_at_liff_mapping,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config, "can_edit_at_liff_mapping", $$v);
      },
      expression: "bookingPreset.config.can_edit_at_liff_mapping"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.bookingPreset.config.can_edit_at_liff_mapping.$error
    }
  }, [_vm._v(" " + _vm._s(_vm.presentValidationErrors("bookingPreset.config.can_edit_at_liff_mapping")) + " ")])], 1)], 1), _c('h5', {
    staticClass: "col-12 col-xl-12 mt-5 mb-3 font-weight-bold"
  }, [_vm._v(" 狀態自動變更 ")]), _c('div', {
    staticClass: "col-12 col-xl-8"
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm"
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: _vm.bookingPreset.config.auto_change_status_enabled,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config, "auto_change_status_enabled", $$v);
      },
      expression: "bookingPreset.config.auto_change_status_enabled"
    }
  }, [_vm._v("啟動狀態自動變更")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "變更日期欄位"
    }
  }, [_c('b-form-select', {
    attrs: {
      "state": _vm.v$.bookingPreset.config.auto_change_status_date_field_id.$error ? false : null,
      "options": _vm.dateFieldCandidates
    },
    model: {
      value: _vm.bookingPreset.config.auto_change_status_date_field_id,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config, "auto_change_status_date_field_id", $$v);
      },
      expression: "bookingPreset.config.auto_change_status_date_field_id"
    }
  }), _vm.v$.bookingPreset.config.auto_change_status_date_field_id.$error ? _c('b-form-invalid-feedback', [_vm._v(" " + _vm._s(_vm.presentValidationErrors('bookingPreset.config.auto_change_status_date_field_id')) + " ")]) : _vm._e()], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "日期當天變更狀態設定"
    }
  }, [_c('JsonEditor', {
    ref: "autoChangeStatusEqual",
    attrs: {
      "height": "150px"
    },
    model: {
      value: _vm.bookingPreset.config.auto_change_status_equal,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config, "auto_change_status_equal", $$v);
      },
      expression: "bookingPreset.config.auto_change_status_equal"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.bookingPreset.config.auto_change_status_equal.$error
    }
  }, [_vm._v(" " + _vm._s(_vm.presentValidationErrors("bookingPreset.config.auto_change_status_equal")) + " ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "超過日期變更狀態設定"
    }
  }, [_c('JsonEditor', {
    ref: "autoChangeStatusOverdue",
    attrs: {
      "height": "150px"
    },
    model: {
      value: _vm.bookingPreset.config.auto_change_status_overdue,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config, "auto_change_status_overdue", $$v);
      },
      expression: "bookingPreset.config.auto_change_status_overdue"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.bookingPreset.config.auto_change_status_overdue.$error
    }
  }, [_vm._v(" " + _vm._s(_vm.presentValidationErrors("bookingPreset.config.auto_change_status_overdue")) + " ")])], 1)], 1)]), _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(" 返回 ")]), _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(" 儲存 ")])], 1)], 1) : _vm._e(), _vm.step == '#wizard-mode' ? _c('section', [_c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2"
  }, [_c('div', {
    staticClass: "col-12 col-xl-12"
  }, [_c('NameBlock', {
    attrs: {
      "label": '預約設定檔名稱',
      "name": _vm.bookingPreset.name
    }
  })], 1), _c('h4', {
    staticClass: "col-12 col-xl-12 mb-3 font-weight-bold"
  }, [_vm._v(" 精靈模式設定 ")]), _c('h5', {
    staticClass: "col-12 col-xl-12 mb-3 font-weight-bold"
  }, [_vm._v(" 分店設定 ")]), _c('div', {
    staticClass: "col-12 col-xl-8"
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "啟用選擇分店"
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: _vm.bookingPreset.config.enabled_selected_branch,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config, "enabled_selected_branch", $$v);
      },
      expression: "bookingPreset.config.enabled_selected_branch"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "顯示分店基本資料"
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: _vm.bookingPreset.config.display_branch_detail,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config, "display_branch_detail", $$v);
      },
      expression: "bookingPreset.config.display_branch_detail"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "基本資料明細"
    }
  }, [_c('JsonEditor', {
    attrs: {
      "lines": 5
    },
    model: {
      value: _vm.bookingPreset.config.branch_detail_mapping,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config, "branch_detail_mapping", $$v);
      },
      expression: "bookingPreset.config.branch_detail_mapping"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "顯示分店圖片"
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: _vm.bookingPreset.config.display_branch_images,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config, "display_branch_images", $$v);
      },
      expression: "bookingPreset.config.display_branch_images"
    }
  })], 1), _c('hr')], 1), _c('h5', {
    staticClass: "col-12 col-xl-12 mb-3 font-weight-bold"
  }, [_vm._v(" 員工設定 ")]), _c('div', {
    staticClass: "col-12 col-xl-8"
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "啟用選擇員工"
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: _vm.bookingPreset.config.enabled_selected_staff,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config, "enabled_selected_staff", $$v);
      },
      expression: "bookingPreset.config.enabled_selected_staff"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "顯示角色過濾"
    }
  }, [_c('JsonEditor', {
    attrs: {
      "height": "32px",
      "disabled": !_vm.bookingPreset.config.enabled_selected_staff
    },
    model: {
      value: _vm.bookingPreset.config.staff_role_filter,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config, "staff_role_filter", $$v);
      },
      expression: "bookingPreset.config.staff_role_filter"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "啟用員工班表設定"
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: _vm.bookingPreset.config.enabled_selected_staff_shift,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config, "enabled_selected_staff_shift", $$v);
      },
      expression: "bookingPreset.config.enabled_selected_staff_shift"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "啟用員工服務關聯"
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: _vm.bookingPreset.config.enabled_staff_service_relation,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config, "enabled_staff_service_relation", $$v);
      },
      expression: "bookingPreset.config.enabled_staff_service_relation"
    }
  })], 1), _c('hr')], 1), _c('h5', {
    staticClass: "col-12 col-xl-12 mb-3 font-weight-bold"
  }, [_vm._v(" 服務設定 ")]), _c('div', {
    staticClass: "col-12 col-xl-8"
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "服務項目欄位"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.serviceFieldCandidates
    },
    on: {
      "change": _vm.changeService
    },
    model: {
      value: _vm.bookingPreset.config.service.service_field_id,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.service, "service_field_id", $$v);
      },
      expression: "bookingPreset.config.service.service_field_id"
    }
  })], 1), _vm.bookingPreset.config.service.collection_id ? _c('div', [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "圖片欄位"
    }
  }, [_c('b-form-select', {
    attrs: {
      "disabled": !_vm.bookingPreset.config.service.service_field_id,
      "options": _vm.collectionItemOptions(_vm.bookingPreset.config.service.collection_id)
    },
    model: {
      value: _vm.bookingPreset.config.service.image_item_id,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.service, "image_item_id", $$v);
      },
      expression: "bookingPreset.config.service.image_item_id"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "標題欄位"
    }
  }, [_c('b-form-select', {
    attrs: {
      "disabled": !_vm.bookingPreset.config.service.collection_id,
      "state": !_vm.v$.bookingPreset.config.service.title_item_id.$error,
      "options": _vm.collectionItemOptions(_vm.bookingPreset.config.service.collection_id)
    },
    model: {
      value: _vm.bookingPreset.config.service.title_item_id,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.service, "title_item_id", $$v);
      },
      expression: "bookingPreset.config.service.title_item_id"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.bookingPreset.config.service.title_item_id.$error
    }
  }, [_vm._v(" " + _vm._s(_vm.presentValidationErrors('bookingPreset.config.service.title_item_id')) + " ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "敘述欄位"
    }
  }, [_c('b-form-select', {
    attrs: {
      "disabled": !_vm.bookingPreset.config.service.collection_id,
      "options": _vm.collectionItemOptions(_vm.bookingPreset.config.service.collection_id)
    },
    model: {
      value: _vm.bookingPreset.config.service.description_item_id,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.service, "description_item_id", $$v);
      },
      expression: "\n                          bookingPreset.config.service.description_item_id\n                        "
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "價格欄位"
    }
  }, [_c('b-form-select', {
    attrs: {
      "disabled": !_vm.bookingPreset.config.service.collection_id,
      "options": _vm.collectionItemOptions(_vm.bookingPreset.config.service.collection_id)
    },
    model: {
      value: _vm.bookingPreset.config.service.price_item_id,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.service, "price_item_id", $$v);
      },
      expression: "bookingPreset.config.service.price_item_id"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "時間欄位"
    }
  }, [_c('b-form-select', {
    attrs: {
      "disabled": !_vm.bookingPreset.config.service.collection_id,
      "options": _vm.collectionItemOptions(_vm.bookingPreset.config.service.collection_id)
    },
    model: {
      value: _vm.bookingPreset.config.service.duration_item_id,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.service, "duration_item_id", $$v);
      },
      expression: "\n                          bookingPreset.config.service.duration_item_id\n                        "
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "允許多選服務"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "disabled": !_vm.bookingPreset.config.service.collection_id
    },
    model: {
      value: _vm.bookingPreset.config.service.can_multiple_select,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.service, "can_multiple_select", $$v);
      },
      expression: "bookingPreset.config.service.can_multiple_select"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "單一服務時自動選擇"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "disabled": !_vm.bookingPreset.config.service.collection_id
    },
    model: {
      value: _vm.bookingPreset.config.service.should_auto_select_the_only_option,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.service, "should_auto_select_the_only_option", $$v);
      },
      expression: "bookingPreset.config.service.should_auto_select_the_only_option"
    }
  })], 1)], 1) : _vm._e(), _c('hr'), _c('h5', {
    staticClass: "col-12 col-xl-12 mb-3 font-weight-bold"
  }, [_vm._v(" 流程設定 ")]), _c('div', {
    staticClass: "col-12 col-xl-8"
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "auto",
      "label-size": "sm",
      "label": "流程順序 - 分店"
    }
  }, [_c('b-form-select', {
    staticClass: "ml-4",
    attrs: {
      "options": _vm.orderOptions
    },
    model: {
      value: _vm.bookingPreset.config.order.branch_page,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.order, "branch_page", $$v);
      },
      expression: "bookingPreset.config.order.branch_page"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "auto",
      "label-size": "sm",
      "label": "流程順序 - 員工"
    }
  }, [_c('b-form-select', {
    staticClass: "ml-4",
    attrs: {
      "options": _vm.orderOptions
    },
    model: {
      value: _vm.bookingPreset.config.order.staff_page,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.order, "staff_page", $$v);
      },
      expression: "bookingPreset.config.order.staff_page"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "auto",
      "label-size": "sm",
      "label": "流程順序 - 服務"
    }
  }, [_c('b-form-select', {
    staticClass: "ml-4",
    attrs: {
      "options": _vm.orderOptions
    },
    model: {
      value: _vm.bookingPreset.config.order.service_page,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.order, "service_page", $$v);
      },
      expression: "bookingPreset.config.order.service_page"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "auto",
      "label-size": "sm",
      "label": "流程順序 - 時間"
    }
  }, [_c('b-form-select', {
    staticClass: "ml-4",
    attrs: {
      "options": _vm.orderOptions
    },
    model: {
      value: _vm.bookingPreset.config.order.schedule_page,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.order, "schedule_page", $$v);
      },
      expression: "bookingPreset.config.order.schedule_page"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "auto",
      "label-size": "sm",
      "label": "流程順序 - 表單"
    }
  }, [_c('b-form-select', {
    staticClass: "ml-4",
    attrs: {
      "options": _vm.orderOptions
    },
    model: {
      value: _vm.bookingPreset.config.order.form_page,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.order, "form_page", $$v);
      },
      expression: "bookingPreset.config.order.form_page"
    }
  })], 1)], 1), _c('hr'), _c('h5', {
    staticClass: "col-12 col-xl-12 mb-3 font-weight-bold"
  }, [_vm._v(" 預約確認頁 ")]), _c('div', {
    staticClass: "col-12 col-xl-8"
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "auto",
      "label-size": "sm",
      "label": "是否啟用"
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: _vm.bookingPreset.config.confirm_page.enable,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.confirm_page, "enable", $$v);
      },
      expression: "bookingPreset.config.confirm_page.enable"
    }
  })], 1)], 1), _c('hr'), _c('div', {
    staticClass: "col-12 col-xl-8"
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "auto",
      "label-size": "sm",
      "label": "送出預約按鈕文字"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: _vm.bookingPreset.config.submit_button_text,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config, "submit_button_text", $$v);
      },
      expression: "bookingPreset.config.submit_button_text"
    }
  })], 1)], 1)], 1)]), _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(" 返回 ")]), _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(" 儲存 ")])], 1)]) : _vm._e(), _vm.step == '#wizard-page' ? _c('section', [_c('h4', {
    staticClass: "mb-3 font-weight-bold"
  }, [_vm._v("精靈時間選擇頁")]), _c('div', {
    staticClass: "col-12 col-xl-8"
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "頁面標題"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text"
    },
    model: {
      value: _vm.bookingPreset.config.schedule_page.title,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.schedule_page, "title", $$v);
      },
      expression: "bookingPreset.config.schedule_page.title"
    }
  })], 1), _c('hr')], 1), _c('div', {
    staticClass: "col-12 col-xl-8"
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "預約提示標題"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text"
    },
    model: {
      value: _vm.bookingPreset.config.booking_tip.form_title,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.booking_tip, "form_title", $$v);
      },
      expression: "bookingPreset.config.booking_tip.form_title"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "預約提示說明"
    }
  }, [_c('b-form-textarea', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    model: {
      value: _vm.bookingPreset.config.booking_tip.form_desc,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.booking_tip, "form_desc", $$v);
      },
      expression: "bookingPreset.config.booking_tip.form_desc"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "啟用 send_messages"
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: _vm.bookingPreset.config.booking_tip.send_messages.enabled,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.booking_tip.send_messages, "enabled", $$v);
      },
      expression: "bookingPreset.config.booking_tip.send_messages.enabled"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "send_messages 內容"
    }
  }, [_c('b-form-textarea', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    model: {
      value: _vm.bookingPreset.config.booking_tip.send_messages.text,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.booking_tip.send_messages, "text", $$v);
      },
      expression: "bookingPreset.config.booking_tip.send_messages.text"
    }
  })], 1), _c('hr'), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "預約提示上方按鈕啟用"
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: _vm.bookingPreset.config.booking_tip.button_top.enabled,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.booking_tip.button_top, "enabled", $$v);
      },
      expression: "bookingPreset.config.booking_tip.button_top.enabled"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "預約提示上方按鈕文字"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    model: {
      value: _vm.bookingPreset.config.booking_tip.button_top.button_text,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.booking_tip.button_top, "button_text", $$v);
      },
      expression: "bookingPreset.config.booking_tip.button_top.button_text"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "預約提示上方按鈕行為"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": ['OA', 'URL', 'Exit']
    },
    model: {
      value: _vm.bookingPreset.config.booking_tip.button_top.button_action,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.booking_tip.button_top, "button_action", $$v);
      },
      expression: "bookingPreset.config.booking_tip.button_top.button_action"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "預約提示上方按鈕網址"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    model: {
      value: _vm.bookingPreset.config.booking_tip.button_top.button_url,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.booking_tip.button_top, "button_url", $$v);
      },
      expression: "bookingPreset.config.booking_tip.button_top.button_url"
    }
  })], 1), _c('hr'), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "預約提示下方按鈕啟用"
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: _vm.bookingPreset.config.booking_tip.button_bottom.enabled,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.booking_tip.button_bottom, "enabled", $$v);
      },
      expression: "bookingPreset.config.booking_tip.button_bottom.enabled"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "預約提示下方按鈕文字"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    model: {
      value: _vm.bookingPreset.config.booking_tip.button_bottom.button_text,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.booking_tip.button_bottom, "button_text", $$v);
      },
      expression: "bookingPreset.config.booking_tip.button_bottom.button_text"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "預約提示下方按鈕行為"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": ['OA', 'URL', 'Exit']
    },
    model: {
      value: _vm.bookingPreset.config.booking_tip.button_bottom.button_action,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.booking_tip.button_bottom, "button_action", $$v);
      },
      expression: "bookingPreset.config.booking_tip.button_bottom.button_action"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "預約提示下方按鈕網址"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    model: {
      value: _vm.bookingPreset.config.booking_tip.button_bottom.button_url,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.booking_tip.button_bottom, "button_url", $$v);
      },
      expression: "bookingPreset.config.booking_tip.button_bottom.button_url"
    }
  })], 1), _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(" 返回 ")]), _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(" 儲存 ")])], 1)], 1)]) : _vm._e(), _vm.step == '#liff-setting' ? _c('section', [_c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2"
  }, [_c('div', {
    staticClass: "col-12 col-xl-12"
  }, [_c('NameBlock', {
    attrs: {
      "label": '預約設定檔名稱',
      "name": _vm.bookingPreset.name
    }
  })], 1), _c('h5', {
    staticClass: "col-12 col-xl-12 mb-3 font-weight-bold"
  }, [_vm._v(" LIFF 預約紀錄 ")]), _c('div', {
    staticClass: "col-12 col-xl-8"
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "預約記錄頁籤"
    }
  }, [_c('JsonEditor', {
    ref: "bookingStatusMapping",
    attrs: {
      "height": "128px"
    },
    model: {
      value: _vm.bookingPreset.config.provider_config.booking_status_mapping,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.provider_config, "booking_status_mapping", $$v);
      },
      expression: "\n                        bookingPreset.config.provider_config.booking_status_mapping\n                      "
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.bookingPreset.config.provider_config.booking_status_mapping.$error
    }
  }, [_vm._v(" " + _vm._s(_vm.presentValidationErrors("bookingPreset.config.provider_config.booking_status_mapping")) + " ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "清單列表欄位"
    }
  }, [_c('JsonEditor', {
    ref: "liffFieldSetting",
    attrs: {
      "height": "128px"
    },
    model: {
      value: _vm.bookingPreset.config.liff_field_setting.list,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.liff_field_setting, "list", $$v);
      },
      expression: "bookingPreset.config.liff_field_setting.list"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.bookingPreset.config.liff_field_setting.list.$error
    }
  }, [_vm._v(" " + _vm._s(_vm.presentValidationErrors("bookingPreset.config.liff_field_setting.list")) + " ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "明細頁狀態變更按鈕"
    }
  }, [_c('JsonEditor', {
    ref: "statusDetector",
    attrs: {
      "height": "128px"
    },
    model: {
      value: _vm.bookingPreset.config.status_detector,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config, "status_detector", $$v);
      },
      expression: "bookingPreset.config.status_detector"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.bookingPreset.config.status_detector.$error
    }
  }, [_vm._v(" " + _vm._s(_vm.presentValidationErrors("bookingPreset.config.status_detector")) + " ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "明細頁通知按鈕"
    }
  }, [_c('JsonEditor', {
    ref: "liffDetailInformButton",
    attrs: {
      "height": "128px"
    },
    model: {
      value: _vm.bookingPreset.config.liff_detail_inform_button,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config, "liff_detail_inform_button", $$v);
      },
      expression: "bookingPreset.config.liff_detail_inform_button"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.bookingPreset.config.liff_detail_inform_button.$error
    }
  }, [_vm._v(" " + _vm._s(_vm.presentValidationErrors("bookingPreset.config.liff_detail_inform_button")) + " ")])], 1)], 1)]), _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(" 返回 ")]), _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(" 儲存 ")])], 1)]) : _vm._e(), _vm.step == '#booking-setting' ? _c('section', [_c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2"
  }, [_c('div', {
    staticClass: "col-12 col-xl-12"
  }, [_c('NameBlock', {
    attrs: {
      "label": '預約設定檔名稱',
      "name": _vm.bookingPreset.name
    }
  })], 1), _c('h4', {
    staticClass: "col-12 col-xl-6 mb-3 font-weight-bold"
  }, [_vm._v(" 推播範本 ")]), _c('div', {
    staticClass: "col-12 col-xl-8"
  }, [_vm.validationErrors ? _c('validation-error-alert', {
    attrs: {
      "errors": _vm.validationErrors
    }
  }) : _vm._e(), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "填寫後貼標"
    }
  }, [_c('TagsBox', {
    model: {
      value: _vm.bookingPreset.config.event_setting.booking_tags,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.event_setting, "booking_tags", $$v);
      },
      expression: "\n                        bookingPreset.config.event_setting.booking_tags\n                      "
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "表頭背景色"
    }
  }, [_c('color-picker', {
    model: {
      value: _vm.bookingPreset.config.push_template.header_bg_color,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.push_template, "header_bg_color", $$v);
      },
      expression: "bookingPreset.config.push_template.header_bg_color"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "按鈕背景色"
    }
  }, [_c('color-picker', {
    model: {
      value: _vm.bookingPreset.config.push_template.button_bg_color,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.push_template, "button_bg_color", $$v);
      },
      expression: "bookingPreset.config.push_template.button_bg_color"
    }
  })], 1)], 1), _c('h4', {
    staticClass: "col-12 col-xl-6 mb-3 font-weight-bold"
  }, [_vm._v(" 預約後推播 ")]), _c('div', {
    staticClass: "col-12 col-xl-8"
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm"
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: _vm.bookingPreset.config.created_push_message,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config, "created_push_message", $$v);
      },
      expression: "bookingPreset.config.created_push_message"
    }
  }, [_vm._v("啟用預約後立即推播")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_vm._v(" 表頭圖片 "), _c('p', {
          staticClass: "text-black-50 mt-2",
          staticStyle: {
            "font-size": ".75rem"
          }
        }, [_vm._v("寬 x 高：1400px x 不限")])];
      },
      proxy: true
    }, {
      key: "default",
      fn: function fn() {
        return [_c('AppFileUploader', {
          attrs: {
            "placeholder-when-empty": ""
          },
          model: {
            value: _vm.bookingPreset.config.created_push_header_image_url,
            callback: function callback($$v) {
              _vm.$set(_vm.bookingPreset.config, "created_push_header_image_url", $$v);
            },
            expression: "bookingPreset.config.created_push_header_image_url"
          }
        })];
      },
      proxy: true
    }], null, false, 1588748033)
  }), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "推播文字"
    }
  }, [_c('b-form-textarea', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "rows": "4"
    },
    model: {
      value: _vm.bookingPreset.config.created_push_message_content,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config, "created_push_message_content", $$v);
      },
      expression: "bookingPreset.config.created_push_message_content"
    }
  })], 1)], 1), _c('h4', {
    staticClass: "col-12 col-xl-6 mb-3 font-weight-bold"
  }, [_vm._v(" 確認後推播 ")]), _c('div', {
    staticClass: "col-12 col-xl-8"
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm"
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: _vm.bookingPreset.config.notify.confirmed.enabled,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.notify.confirmed, "enabled", $$v);
      },
      expression: "bookingPreset.config.notify.confirmed.enabled"
    }
  }, [_vm._v("啟用確認後推播")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_vm._v(" 表頭圖片 "), _c('p', {
          staticClass: "text-black-50 mt-2",
          staticStyle: {
            "font-size": ".75rem"
          }
        }, [_vm._v("寬 x 高：1400px x 不限")])];
      },
      proxy: true
    }, {
      key: "default",
      fn: function fn() {
        return [_c('AppFileUploader', {
          attrs: {
            "placeholder-when-empty": ""
          },
          model: {
            value: _vm.bookingPreset.config.confirmed_push_header_image_url,
            callback: function callback($$v) {
              _vm.$set(_vm.bookingPreset.config, "confirmed_push_header_image_url", $$v);
            },
            expression: "bookingPreset.config.confirmed_push_header_image_url"
          }
        })];
      },
      proxy: true
    }], null, false, 1764080562)
  }), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "推播文字"
    }
  }, [_c('b-form-textarea', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "rows": "4"
    },
    model: {
      value: _vm.bookingPreset.config.confirmed_push_message_content,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config, "confirmed_push_message_content", $$v);
      },
      expression: "bookingPreset.config.confirmed_push_message_content"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "狀態定義"
    }
  }, [_c('JsonEditor', {
    ref: "confirmedStatusMappingRef",
    attrs: {
      "height": "64px"
    },
    model: {
      value: _vm.bookingPreset.config.notify.confirmed.status_mapping,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.notify.confirmed, "status_mapping", $$v);
      },
      expression: "bookingPreset.config.notify.confirmed.status_mapping"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.bookingPreset.config.notify.confirmed.status_mapping.$error
    }
  }, [_vm._v(" " + _vm._s(_vm.presentValidationErrors("bookingPreset.config.confirmed_push_message_content")) + " ")])], 1)], 1), _c('h4', {
    staticClass: "col-12 col-xl-6 mb-3 font-weight-bold"
  }, [_vm._v(" 完成後推播 ")]), _c('div', {
    staticClass: "col-12 col-xl-8"
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm"
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: _vm.bookingPreset.config.notify.completed.enabled,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.notify.completed, "enabled", $$v);
      },
      expression: "bookingPreset.config.notify.completed.enabled"
    }
  }, [_vm._v("啟用完成後推播")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_vm._v(" 表頭圖片 "), _c('p', {
          staticClass: "text-black-50 mt-2",
          staticStyle: {
            "font-size": ".75rem"
          }
        }, [_vm._v("寬 x 高：1400px x 不限")])];
      },
      proxy: true
    }, {
      key: "default",
      fn: function fn() {
        return [_c('AppFileUploader', {
          attrs: {
            "placeholder-when-empty": ""
          },
          model: {
            value: _vm.bookingPreset.config.completed_push_header_image_url,
            callback: function callback($$v) {
              _vm.$set(_vm.bookingPreset.config, "completed_push_header_image_url", $$v);
            },
            expression: "bookingPreset.config.completed_push_header_image_url"
          }
        })];
      },
      proxy: true
    }], null, false, 525726476)
  }), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "推播文字"
    }
  }, [_c('b-form-textarea', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "rows": "4"
    },
    model: {
      value: _vm.bookingPreset.config.completed_push_message_content,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config, "completed_push_message_content", $$v);
      },
      expression: "bookingPreset.config.completed_push_message_content"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "狀態定義"
    }
  }, [_c('JsonEditor', {
    ref: "cancelNotifyRef",
    attrs: {
      "height": "64px"
    },
    model: {
      value: _vm.bookingPreset.config.notify.completed.status_mapping,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.notify.completed, "status_mapping", $$v);
      },
      expression: "bookingPreset.config.notify.completed.status_mapping"
    }
  })], 1)], 1), _c('h4', {
    staticClass: "col-12 col-xl-6 mb-3 font-weight-bold"
  }, [_vm._v(" 取消後推播 ")]), _c('div', {
    staticClass: "col-12 col-xl-8"
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm"
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: _vm.bookingPreset.config.notify.cancel.enabled,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.notify.cancel, "enabled", $$v);
      },
      expression: "bookingPreset.config.notify.cancel.enabled"
    }
  }, [_vm._v("啟用取消後推播")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_vm._v(" 表頭圖片 "), _c('p', {
          staticClass: "text-black-50 mt-2",
          staticStyle: {
            "font-size": ".75rem"
          }
        }, [_vm._v("寬 x 高：1400px x 不限")])];
      },
      proxy: true
    }, {
      key: "default",
      fn: function fn() {
        return [_c('AppFileUploader', {
          attrs: {
            "placeholder-when-empty": ""
          },
          model: {
            value: _vm.bookingPreset.config.canceled_push_header_image_url,
            callback: function callback($$v) {
              _vm.$set(_vm.bookingPreset.config, "canceled_push_header_image_url", $$v);
            },
            expression: "bookingPreset.config.canceled_push_header_image_url"
          }
        })];
      },
      proxy: true
    }], null, false, 4269656006)
  }), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "推播文字"
    }
  }, [_c('b-form-textarea', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "rows": "4"
    },
    model: {
      value: _vm.bookingPreset.config.canceled_push_message_content,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config, "canceled_push_message_content", $$v);
      },
      expression: "bookingPreset.config.canceled_push_message_content"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "狀態定義"
    }
  }, [_c('JsonEditor', {
    ref: "cancelNotifyRef",
    attrs: {
      "height": "64px"
    },
    model: {
      value: _vm.bookingPreset.config.notify.cancel.status_mapping,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.notify.cancel, "status_mapping", $$v);
      },
      expression: "bookingPreset.config.notify.cancel.status_mapping"
    }
  })], 1)], 1), _c('h4', {
    staticClass: "col-12 col-xl-6 mb-3 font-weight-bold"
  }, [_vm._v(" 修改後推播 ")]), _c('div', {
    staticClass: "col-12 col-xl-8"
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm"
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: _vm.bookingPreset.config.notify.edit.enabled,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.notify.edit, "enabled", $$v);
      },
      expression: "bookingPreset.config.notify.edit.enabled"
    }
  }, [_vm._v("啟用修改後推播")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_vm._v(" 表頭圖片 "), _c('p', {
          staticClass: "text-black-50 mt-2",
          staticStyle: {
            "font-size": ".75rem"
          }
        }, [_vm._v("寬 x 高：1400px x 不限")])];
      },
      proxy: true
    }, {
      key: "default",
      fn: function fn() {
        return [_c('AppFileUploader', {
          attrs: {
            "placeholder-when-empty": ""
          },
          model: {
            value: _vm.bookingPreset.config.modified_push_header_image_url,
            callback: function callback($$v) {
              _vm.$set(_vm.bookingPreset.config, "modified_push_header_image_url", $$v);
            },
            expression: "bookingPreset.config.modified_push_header_image_url"
          }
        })];
      },
      proxy: true
    }], null, false, 1647932064)
  }), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "推播文字"
    }
  }, [_c('b-form-textarea', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "rows": "4"
    },
    model: {
      value: _vm.bookingPreset.config.modified_push_message_content,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config, "modified_push_message_content", $$v);
      },
      expression: "bookingPreset.config.modified_push_message_content"
    }
  })], 1)], 1), _c('h4', {
    staticClass: "col-12 col-xl-6 mb-3 font-weight-bold"
  }, [_vm._v(" 每日提醒推播 ")]), _c('div', {
    staticClass: "col-12 col-xl-8"
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "推播設定"
    }
  }, [_c('JsonEditor', {
    ref: "dailyBookingReminder",
    attrs: {
      "height": "128px"
    },
    model: {
      value: _vm.bookingPreset.config.daily_booking_reminder,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config, "daily_booking_reminder", $$v);
      },
      expression: "bookingPreset.config.daily_booking_reminder"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.bookingPreset.config.daily_booking_reminder.$error
    }
  }, [_vm._v(" " + _vm._s(_vm.presentValidationErrors('bookingPreset.config.daily_booking_reminder')) + " ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "推播文字"
    }
  }, [_c('b-form-textarea', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "rows": "4"
    },
    model: {
      value: _vm.bookingPreset.config.every_day_message,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config, "every_day_message", $$v);
      },
      expression: "bookingPreset.config.every_day_message"
    }
  })], 1)], 1), _c('h4', {
    staticClass: "col-12 col-xl-6 mb-3 font-weight-bold"
  }, [_vm._v(" 後台推播設定 ")]), _c('div', {
    staticClass: "col-12 col-xl-8"
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "狀態變更設定"
    }
  }, [_c('JsonEditor', {
    ref: "statusChangeEvent",
    attrs: {
      "height": "128px"
    },
    model: {
      value: _vm.bookingPreset.config.status_change_events,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config, "status_change_events", $$v);
      },
      expression: "bookingPreset.config.status_change_events"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.bookingPreset.config.status_change_events.$error
    }
  }, [_vm._v(" " + _vm._s(_vm.presentValidationErrors("bookingPreset.config.status_change_events")) + " ")])], 1), _c('h4', {
    staticClass: "col-12 col-xl-6 mb-3 font-weight-bold"
  }, [_vm._v(" 員工推播 ")]), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm"
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: _vm.bookingPreset.config.line_push.staff_push.enabled,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.line_push.staff_push, "enabled", $$v);
      },
      expression: "bookingPreset.config.line_push.staff_push.enabled"
    }
  }, [_vm._v("啟用員工推播")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_vm._v(" 推播範本 "), _c('p', {
          staticClass: "text-black-50 mt-2",
          staticStyle: {
            "font-size": ".75rem"
          }
        }, [_vm._v("booking_staff_message")])];
      },
      proxy: true
    }], null, false, 1418892390)
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text"
    },
    model: {
      value: _vm.bookingPreset.config.line_push.staff_push.template,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.line_push.staff_push, "template", $$v);
      },
      expression: "bookingPreset.config.line_push.staff_push.template"
    }
  })], 1)], 1)]), _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(" 返回 ")]), _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(" 儲存 ")])], 1)]) : _vm._e(), _vm.step == '#linked-application' ? _c('section', [_c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2"
  }, [_c('div', {
    staticClass: "col-12 col-xl-12"
  }, [_c('NameBlock', {
    attrs: {
      "label": '預約設定檔名稱',
      "name": _vm.bookingPreset.name
    }
  })], 1), _c('h5', {
    staticClass: "col-12 col-xl-12 mb-3 font-weight-bold"
  }, [_vm._v(" 連動中應用 ")]), _c('h4', {
    staticClass: "col-12 col-xl-6 mb-3 font-weight-bold"
  }, [_vm._v(" 客戶員工關聯 ")]), _c('div', {
    staticClass: "col-12 col-xl-8"
  }, [_vm.validationErrors ? _c('validation-error-alert', {
    attrs: {
      "errors": _vm.validationErrors
    }
  }) : _vm._e(), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm"
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: _vm.bookingPreset.config.customer_staff.enable,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.customer_staff, "enable", $$v);
      },
      expression: "bookingPreset.config.customer_staff.enable"
    }
  }, [_vm._v(" 建立客戶員工關聯 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "關聯類型"
    }
  }, [_c('b-form-input', {
    model: {
      value: _vm.bookingPreset.config.customer_staff.bound_type,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.customer_staff, "bound_type", $$v);
      },
      expression: "bookingPreset.config.customer_staff.bound_type"
    }
  })], 1)], 1), _c('h4', {
    staticClass: "col-12 col-xl-6 mb-3 font-weight-bold"
  }, [_vm._v(" 客戶分店關聯 ")]), _c('div', {
    staticClass: "col-12 col-xl-8"
  }, [_vm.validationErrors ? _c('validation-error-alert', {
    attrs: {
      "errors": _vm.validationErrors
    }
  }) : _vm._e(), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm"
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: _vm.bookingPreset.config.customer_branches.enable,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.customer_branches, "enable", $$v);
      },
      expression: "bookingPreset.config.customer_branches.enable"
    }
  }, [_vm._v(" 建立客戶分店關聯 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "關聯類型"
    }
  }, [_c('b-form-input', {
    model: {
      value: _vm.bookingPreset.config.customer_branches.bound_type,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.customer_branches, "bound_type", $$v);
      },
      expression: "bookingPreset.config.customer_branches.bound_type"
    }
  })], 1)], 1), _c('h4', {
    staticClass: "col-12 col-xl-6 mb-3 font-weight-bold"
  }, [_vm._v(" 聊天室 ")]), _c('div', {
    staticClass: "col-12 col-xl-8"
  }, [_vm.validationErrors ? _c('validation-error-alert', {
    attrs: {
      "errors": _vm.validationErrors
    }
  }) : _vm._e(), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm"
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: _vm.bookingPreset.config.chatroom.enable,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.chatroom, "enable", $$v);
      },
      expression: "bookingPreset.config.chatroom.enable"
    }
  }, [_vm._v(" 啟用 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "來源類型"
    }
  }, [_c('b-form-select', {
    model: {
      value: _vm.bookingPreset.config.chatroom.source_type,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.chatroom, "source_type", $$v);
      },
      expression: "bookingPreset.config.chatroom.source_type"
    }
  }, [_c('b-form-select-option', {
    attrs: {
      "value": "booking"
    }
  }, [_vm._v("預約")]), _c('b-form-select-option', {
    attrs: {
      "value": "customer_staff"
    }
  }, [_vm._v("客戶員工關聯")]), _c('b-form-select-option', {
    attrs: {
      "value": "customer_branches"
    }
  }, [_vm._v("客戶分店關聯")])], 1)], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm"
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: _vm.bookingPreset.config.chatroom.is_auto,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.chatroom, "is_auto", $$v);
      },
      expression: "bookingPreset.config.chatroom.is_auto"
    }
  }, [_vm._v(" 預約後自動建立 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm"
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: _vm.bookingPreset.config.chatroom.invite_booked_staff,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.chatroom, "invite_booked_staff", $$v);
      },
      expression: "bookingPreset.config.chatroom.invite_booked_staff"
    }
  }, [_vm._v(" 將被預約的員工加入聊天室 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm"
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: _vm.bookingPreset.config.chatroom.invite_branches_staff,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.chatroom, "invite_branches_staff", $$v);
      },
      expression: "bookingPreset.config.chatroom.invite_branches_staff"
    }
  }, [_vm._v(" 邀請分店員工 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "請輸入分店員工角色"
    }
  }, [_c('JsonEditor', {
    attrs: {
      "height": "128px"
    },
    model: {
      value: _vm.bookingPreset.config.chatroom.invite_branches_staff_by_roles,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.chatroom, "invite_branches_staff_by_roles", $$v);
      },
      expression: "bookingPreset.config.chatroom.invite_branches_staff_by_roles"
    }
  })], 1)], 1)]), _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(" 返回 ")]), _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(" 儲存 ")])], 1)]) : _vm._e(), _vm.step == '#pages-and-sections' ? _c('section', [_c('NameBlock', {
    attrs: {
      "label": '預約設定檔名稱',
      "name": _vm.bookingPreset.name
    }
  }), _c('PageAndSectionEditor', {
    attrs: {
      "editor-title": "分頁與分區設定",
      "inputSubjects": _vm.bookingPreset.config.fields,
      "pages": _vm.bookingPreset.config.pages,
      "sections": _vm.bookingPreset.config.sections,
      "expand-slot-area": ""
    },
    on: {
      "update:pages": function updatePages($event) {
        return _vm.$set(_vm.bookingPreset.config, "pages", $event);
      },
      "update:sections": function updateSections($event) {
        return _vm.$set(_vm.bookingPreset.config, "sections", $event);
      },
      "output": _vm.handlePageAndSectionUpdate,
      "cancel": _vm.cancel
    }
  })], 1) : _vm._e(), _vm.step == '#collection-info' ? _c('section', [_c('NameBlock', {
    attrs: {
      "label": '預約設定檔名稱',
      "name": _vm.bookingPreset.name
    }
  }), _c('h4', {
    staticClass: "font-weight-bold"
  }, [_vm._v("欄位資訊")]), _vm.bookingPreset.id ? _c('DynamicFormReadOnly', {
    attrs: {
      "input-subjects": _vm.bookingPreset.config.fields
    },
    on: {
      "cancel": function cancel($event) {
        return _vm.$router.push({
          name: 'BookingPresetList'
        });
      }
    }
  }) : _vm._e()], 1) : _vm._e(), _vm.step == '#booking-list-quotation-setting' && _vm.checkPermission([_vm.consts.BOOKING_LIST_QUOTATION_SETTING]) ? _c('section', [_c('NameBlock', {
    attrs: {
      "label": '預約設定檔名稱',
      "name": _vm.bookingPreset.name
    }
  }), _c('h4', {
    staticClass: "font-weight-bold"
  }, [_vm._v("估價單設定")]), _c('div', {
    staticClass: "col-12 col-xl-12"
  }, [_vm.validationErrors ? _c('validation-error-alert', {
    attrs: {
      "errors": _vm.validationErrors
    }
  }) : _vm._e(), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "12",
      "label-size": "sm",
      "label": "表頭設定"
    }
  }, [_c('b-form-textarea', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "rows": "10"
    },
    model: {
      value: _vm.bookingPreset.config.quotation_header,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config, "quotation_header", $$v);
      },
      expression: "bookingPreset.config.quotation_header"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "12",
      "label-size": "sm",
      "label": "內容標題"
    }
  }, [_c('b-input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "請輸入內容標題"
    },
    model: {
      value: _vm.bookingPreset.config.quotation_title,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config, "quotation_title", $$v);
      },
      expression: "bookingPreset.config.quotation_title"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "12",
      "label-size": "sm",
      "label": "內容副標題"
    }
  }, [_c('b-input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "請輸入內容副標題"
    },
    model: {
      value: _vm.bookingPreset.config.quotation_subTitle,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config, "quotation_subTitle", $$v);
      },
      expression: "bookingPreset.config.quotation_subTitle"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "12",
      "label-size": "sm"
    }
  }, [_c('span', {
    attrs: {
      "id": "quotation-content-header-tooltip"
    }
  }, [_vm._v(" 內容表頭設定 "), _c('span', {
    staticClass: "mdi mdi-information"
  })]), _c('b-tooltip', {
    attrs: {
      "placement": "top",
      "target": "quotation-content-header-tooltip"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn() {
        return [_c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_c('span', [_vm._v("優先出現field_id，對應的文字，如果不存在或為空，則出現text中的文字")]), _c('br'), _c('span', [_vm._v("{")]), _c('br'), _c('span', [_vm._v("\"text\": \"純文字\",")]), _c('br'), _c('span', [_vm._v("\"style\": \"顯示的style\",")]), _c('br'), _c('span', [_vm._v("\"colspan\": \"所佔的格數，數字表示\",")]), _c('br'), _c('span', [_vm._v("\"field_id\": \"data的field_id，會轉換成對應的文字\"")]), _c('br'), _c('span', [_vm._v("}")]), _c('br')])];
      },
      proxy: true
    }], null, false, 3145064703)
  }), _c('JsonEditor', {
    ref: "quotationContentHeaderManagement",
    attrs: {
      "height": "256px"
    },
    model: {
      value: _vm.bookingPreset.config.quotation_content_header,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config, "quotation_content_header", $$v);
      },
      expression: "bookingPreset.config.quotation_content_header"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.bookingPreset.config.quotation_content_header.$error
    }
  }, [_vm._v(" " + _vm._s(_vm.presentValidationErrors('bookingPreset.config.quotation_content_header')) + " ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "12",
      "label-size": "sm"
    }
  }, [_c('span', {
    attrs: {
      "id": "quotation-content-tooltip"
    }
  }, [_vm._v(" 內容設定 "), _c('span', {
    staticClass: "mdi mdi-information"
  })]), _c('b-tooltip', {
    attrs: {
      "placement": "top",
      "target": "quotation-content-tooltip"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn() {
        return [_c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_c('span', [_vm._v("優先出現field_id，對應的文字，如果不存在或為空，則出現text中的文字")]), _c('br'), _c('span', [_vm._v("{")]), _c('br'), _c('span', [_vm._v("\"text\": \"純文字\",")]), _c('br'), _c('span', [_vm._v("\"style\": \"顯示的style\",")]), _c('br'), _c('span', [_vm._v("\"colspan\": \"所佔的格數，數字表示\",")]), _c('br'), _c('span', [_vm._v("\"field_id\": \"data的field_id，會轉換成對應的文字\"")]), _c('br'), _c('span', [_vm._v("}")]), _c('br')])];
      },
      proxy: true
    }], null, false, 3145064703)
  }), _c('JsonEditor', {
    ref: "quotationContentManagement",
    attrs: {
      "height": "256px"
    },
    model: {
      value: _vm.bookingPreset.config.quotation_content,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config, "quotation_content", $$v);
      },
      expression: "bookingPreset.config.quotation_content"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.bookingPreset.config.quotation_content.$error
    }
  }, [_vm._v(" " + _vm._s(_vm.presentValidationErrors('bookingPreset.config.quotation_content')) + " ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "12",
      "label-size": "sm"
    }
  }, [_c('span', {
    attrs: {
      "id": "quotation-content-footer-tooltip"
    }
  }, [_vm._v(" 內容頁尾設定 "), _c('span', {
    staticClass: "mdi mdi-information"
  })]), _c('b-tooltip', {
    attrs: {
      "placement": "top",
      "target": "quotation-content-footer-tooltip"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn() {
        return [_c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_c('span', [_vm._v("優先出現field_id，對應的文字，如果不存在或為空，則出現text中的文字")]), _c('br'), _c('span', [_vm._v("{")]), _c('br'), _c('span', [_vm._v("\"text\": \"純文字\",")]), _c('br'), _c('span', [_vm._v("\"style\": \"顯示的style\",")]), _c('br'), _c('span', [_vm._v("\"colspan\": \"所佔的格數，數字表示\",")]), _c('br'), _c('span', [_vm._v("\"field_id\": \"data的field_id，會轉換成對應的文字\"")]), _c('br'), _c('span', [_vm._v("}")]), _c('br')])];
      },
      proxy: true
    }], null, false, 3145064703)
  }), _c('JsonEditor', {
    ref: "quotationContentFooterManagement",
    attrs: {
      "height": "256px"
    },
    model: {
      value: _vm.bookingPreset.config.quotation_content_footer,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config, "quotation_content_footer", $$v);
      },
      expression: "bookingPreset.config.quotation_content_footer"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.bookingPreset.config.quotation_content_footer.$error
    }
  }, [_vm._v(" " + _vm._s(_vm.presentValidationErrors('bookingPreset.config.quotation_content_footer')) + " ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "12",
      "label-size": "sm",
      "label": "頁尾設定"
    }
  }, [_c('b-form-textarea', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "rows": "10"
    },
    model: {
      value: _vm.bookingPreset.config.quotation_footer,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config, "quotation_footer", $$v);
      },
      expression: "bookingPreset.config.quotation_footer"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "12",
      "label-size": "sm",
      "label": "發票買受人統一編號欄位"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.collectionFieldCandidatesWithEmptyString
    },
    model: {
      value: _vm.bookingPreset.config.buyer_business_number_id,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config, "buyer_business_number_id", $$v);
      },
      expression: "bookingPreset.config.buyer_business_number_id"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "12",
      "label-size": "sm",
      "label": "發票買受人公司名稱欄位"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.collectionFieldCandidatesWithEmptyString
    },
    model: {
      value: _vm.bookingPreset.config.buyer_company_name_id,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config, "buyer_company_name_id", $$v);
      },
      expression: "bookingPreset.config.buyer_company_name_id"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "12",
      "label-size": "sm",
      "label": "發票品名",
      "description": "開立發票時的品名，留空則使用系統預設"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "車資"
    },
    model: {
      value: _vm.bookingPreset.config.invoice_item_name,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config, "invoice_item_name", $$v);
      },
      expression: "bookingPreset.config.invoice_item_name"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "12",
      "label-size": "sm",
      "label": "發票開立日期",
      "description": "\u652F\u63F4\u8B8A\u6578\uFF1A{{$booking_data['StartDate']}}\uFF0C\u7559\u7A7A\u5247\u4F7F\u7528\u7576\u5929\u65E5\u671F"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "{{$booking_data['StartDate']}}"
    },
    model: {
      value: _vm.bookingPreset.config.invoice_issue_date,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config, "invoice_issue_date", $$v);
      },
      expression: "bookingPreset.config.invoice_issue_date"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "12",
      "label-size": "sm",
      "label": "發票備註",
      "description": "\u652F\u63F4\u8B8A\u6578\uFF1A{{$booking_data['StartDate']}}\u3001{{$booking_data['StartDateTime']}}\u3001{{$booking_data['StartToEndDate']}} \u7B49\uFF0C\u7559\u7A7A\u5247\u4F7F\u7528\u7CFB\u7D71\u9810\u8A2D"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "{{$booking_data['StartToEndDate']}} \u7528\u8ECA"
    },
    model: {
      value: _vm.bookingPreset.config.invoice_remark,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config, "invoice_remark", $$v);
      },
      expression: "bookingPreset.config.invoice_remark"
    }
  })], 1), _c('div', {
    staticClass: "d-flex justify-content-center mt-2"
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(" 返回 ")]), _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(" 儲存 ")])], 1)], 1)], 1) : _vm._e(), _vm.step == '#limit-setting' ? _c('section', [_c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2"
  }, [_c('div', {
    staticClass: "col-12 col-xl-12"
  }, [_c('NameBlock', {
    attrs: {
      "label": '預約設定檔名稱',
      "name": _vm.bookingPreset.name
    }
  })], 1), _c('h4', {
    staticClass: "col-12 col-xl-12 mb-3 font-weight-bold"
  }, [_vm._v(" 預約次數限制 ")]), _c('div', {
    staticClass: "col-12 col-xl-8"
  }, [_c('b-form-checkbox', {
    attrs: {
      "disabled": !_vm.bookingPreset.config.booking_mapping.bookings.start_at
    },
    model: {
      value: _vm.bookingPreset.config.occupy_config.enable,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.occupy_config, "enable", $$v);
      },
      expression: "bookingPreset.config.occupy_config.enable"
    }
  }, [_vm._v(" 預約次數限制 ")])], 1), _c('h5', {
    staticClass: "col-12 col-xl-12 mb-3 font-weight-bold mt-2"
  }, [_vm._v(" 檢查條件 ")]), _c('div', {
    staticClass: "col-12 col-xl-8"
  }, [_c('ul', {
    staticClass: "list-none pl-0 mb-3"
  }, [_c('li', {
    staticClass: "mb-2"
  }, [_c('b-form-checkbox', {
    attrs: {
      "disabled": !_vm.bookingPreset.config.occupy_config.enable
    },
    model: {
      value: _vm.bookingPreset.config.occupy_config.enable,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.occupy_config, "enable", $$v);
      },
      expression: "bookingPreset.config.occupy_config.enable"
    }
  }, [_vm._v("預約時段")])], 1), _c('li', {
    staticClass: "mb-2"
  }, [_c('b-form-checkbox', {
    attrs: {
      "disabled": !_vm.bookingPreset.config.occupy_config.enable
    },
    model: {
      value: _vm.bookingPreset.config.occupy_config.is_check_collection,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.occupy_config, "is_check_collection", $$v);
      },
      expression: "bookingPreset.config.occupy_config.is_check_collection"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.collectionOptions,
      "disabled": !_vm.bookingPreset.config.occupy_config.is_check_collection
    },
    model: {
      value: _vm.bookingPreset.config.occupy_config.collection_id,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.occupy_config, "collection_id", $$v);
      },
      expression: "bookingPreset.config.occupy_config.collection_id"
    }
  })], 1)], 1), _c('li', {
    staticClass: "mb-2"
  }, [_c('b-form-checkbox', {
    attrs: {
      "disabled": !_vm.bookingPreset.config.occupy_config.enable
    },
    model: {
      value: _vm.bookingPreset.config.occupy_config.is_check_branch,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.occupy_config, "is_check_branch", $$v);
      },
      expression: "bookingPreset.config.occupy_config.is_check_branch"
    }
  }, [_vm._v("分店")])], 1), _c('li', {
    staticClass: "mb-2"
  }, [_c('b-form-checkbox', {
    attrs: {
      "disabled": !_vm.bookingPreset.config.occupy_config.enable || _vm.bookingPreset.type !== 'wizard'
    },
    model: {
      value: _vm.bookingPreset.config.occupy_config.is_check_staff,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.occupy_config, "is_check_staff", $$v);
      },
      expression: "bookingPreset.config.occupy_config.is_check_staff"
    }
  }, [_vm._v("員工")])], 1), _c('li', [_c('b-form-checkbox', {
    attrs: {
      "disabled": !_vm.bookingPreset.config.occupy_config.enable || _vm.bookingPreset.type !== 'wizard'
    },
    model: {
      value: _vm.bookingPreset.config.occupy_config.is_check_service,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.occupy_config, "is_check_service", $$v);
      },
      expression: "bookingPreset.config.occupy_config.is_check_service"
    }
  }, [_vm._v("服務項目")])], 1)])]), _c('h5', {
    staticClass: "col-12 col-xl-12 mb-3 font-weight-bold"
  }, [_vm._v(" 名額佔用規則 ")]), _c('div', {
    staticClass: "col-12 col-xl-8"
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "填入佔用名額的預約狀態"
    }
  }, [_c('JsonEditor', {
    attrs: {
      "height": "32px",
      "disabled": !_vm.bookingPreset.config.occupy_config.enable
    },
    model: {
      value: _vm.bookingPreset.config.occupy_config.occupy_status,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.occupy_config, "occupy_status", $$v);
      },
      expression: "bookingPreset.config.occupy_config.occupy_status"
    }
  })], 1)], 1), _c('h5', {
    staticClass: "col-12 col-xl-12 mb-3 font-weight-bold"
  }, [_vm._v(" 次數上限 ")]), _c('div', {
    staticClass: "col-12 col-xl-8"
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": ""
    }
  }, [_c('b-form-radio-group', {
    model: {
      value: _vm.bookingPreset.config.occupy_config.limit_type,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.occupy_config, "limit_type", $$v);
      },
      expression: "bookingPreset.config.occupy_config.limit_type"
    }
  }, [_c('b-form-radio', {
    staticClass: "form-inline mb-2 col-12",
    attrs: {
      "value": "collection",
      "disabled": !_vm.bookingPreset.config.occupy_config.is_check_collection
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.collectionOptions,
      "disabled": true
    },
    model: {
      value: _vm.bookingPreset.config.occupy_config.collection_id,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.occupy_config, "collection_id", $$v);
      },
      expression: "bookingPreset.config.occupy_config.collection_id"
    }
  }), _c('b-form-select', {
    staticClass: "ml-2",
    attrs: {
      "options": _vm.collectionItemOptions(_vm.bookingPreset.config.occupy_config.collection_id),
      "disabled": !(_vm.bookingPreset.config.occupy_config.limit_type == 'collection')
    },
    model: {
      value: _vm.bookingPreset.config.occupy_config.collection_field_id,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.occupy_config, "collection_field_id", $$v);
      },
      expression: "bookingPreset.config.occupy_config.collection_field_id"
    }
  })], 1), _c('b-form-radio', {
    staticClass: "form-inline mb-2 col-12",
    attrs: {
      "value": "time",
      "disabled": !_vm.limitTimeField
    }
  }, [_vm._v(" 依時段設定 時段限定 "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.bookingPreset.config.occupy_config.slot_people,
      expression: "bookingPreset.config.occupy_config.slot_people"
    }],
    staticClass: "mb-2 mr-sm-2 mb-sm-0 w-4",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.bookingPreset.config.occupy_config.slot_people
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.bookingPreset.config.occupy_config, "slot_people", $event.target.value);
      }
    }
  }), _vm._v(" 人 ")])], 1)], 1)], 1), _c('h5', {
    staticClass: "col-12 col-xl-12 mb-3 font-weight-bold"
  }, [_vm._v(" 前台用戶顯示設定 ")]), _c('div', {
    staticClass: "col-12 col-xl-8"
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "額滿提示文字"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "請填入預約額滿的提示訊息"
    },
    model: {
      value: _vm.bookingPreset.config.occupy_config.full_alert_text,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.occupy_config, "full_alert_text", $$v);
      },
      expression: "bookingPreset.config.occupy_config.full_alert_text"
    }
  })], 1)], 1)]), _c('div', {
    staticClass: "d-flex justify-content-center mt-2"
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(" 返回 ")]), _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(" 儲存 ")])], 1)]) : _vm._e()])], 1)], 1)])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }